import React from 'react';
import { getMaskPhone, shortText, ucWords } from '../../../Utilities/Utilities';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';
import { FcIphone } from 'react-icons/fc';
import { BiPhone } from 'react-icons/bi';
import { MdOutlineEmail } from 'react-icons/md';
import parse from 'html-react-parser';

function ReferralList({
  item,
  handlePopupOpen,
  handleDeleteReferral,
  handleReload,
  handleChangeStatus,
}) {
  return (
    <>
	 <div className="border-r border-r-lightgray p-1-5">
        <select
          name="action"
          id="action"
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const action = e.target.value;
            handleChangeStatus(item.id, action);
          }}
          value={item?.referral_status?.toString()}
        >
          <option value="1">Pending</option>
          <option value="2">Scheduled</option>
          <option value="3">Completed</option>
          <option value="4">Canceled</option>
          <option value="5">Removed</option>
        </select>
     </div>
	<div className="border-r border-r-lightgray p-1-5">{item.chart_number}</div>
     <div className="border-r border-r-lightgray p-1-5">

        <Link
          to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item.patient_id}`}
          onClick={(e) => e.stopPropagation()}
        >{`${ucWords(item.patientName)}`}</Link>
        <br />
        {`${ucWords(item.gender)} ${item?.dob}`}
      </div>
      {/* <div className="border-r border-r-lightgray p-1-5">
        <FcIphone /> {item.mobile ? item.mobile : ' N/A'}
        <br />
        <BiPhone /> {item?.home_phone ? item?.home_phone : ' N/A'}
        <br />
        <MdOutlineEmail className='mr-1' />
        {item?.patEmail ? item?.patEmail : ' N/A'}
      </div>
      <div className="border-r border-r-lightgray p-1-5">
        {`${ucWords(item.address)},`}
        <br />
        {`${ucWords(item.city)},`}
        <br />
        {`${ucWords(item.state_name)}`} <br />
        {item.zip}

</div> */}
      <div className="border-r border-r-lightgray p-1-5">
        {parse(shortText(item?.referal_name, 13))}
      </div>
      <div className="border-r border-r-lightgray p-1-5">
        {parse(shortText(item?.reciverNane, 13))}
        <br />
        {getMaskPhone(item?.fax)}
      </div>
	  <div className="border-r border-r-lightgray p-1-5">{parse(item?.urgency)}</div>
      <div className="border-r border-r-lightgray p-1-5" title={item?.reason}>{parse(item?.reasonForReferral)}</div>
      <div className="border-r border-r-lightgray p-1-5">{item?.planDate}</div>
		  {/* <div className="border-r border-r-lightgray p-1-5">{item?.noteStatus}</div>
      <div className="border-r border-r-lightgray p-1-5">
        <Link
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            );
          }}
        >{`${item?.docSent}`}</Link>{' '}
        /{' '}
        <Link
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            );
          }}
        >
          View
        </Link>
		  </div> */}
      <div className="border-r border-r-lightgray p-1-5">
        Appt.:{' '}
        <Link
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            );
          }}
        >
          {item?.appTaken}
        </Link>{' '}
        
        <span style={{ marginTop: "7px", width:"100%", display:"inline-block", color:"#717171" }}> {item?.appointmentTakenDate && item?.appointmentTakenDate}</span>
        <span style={{ marginTop: "7px", width:"100%", display:"inline-block" }}>
        Pt. Informed:
        <Link
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            );
          }}
		  
        >
          {item?.patInformed}
        </Link>
		</span>
      </div>
      <div className="border-r border-r-lightgray p-1-5">
	  {/*  <Link
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            );
          }}
        >
          New Referral
        </Link>
        {` | `}
        <Link
          className="red"
          to={`#`}
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteReferral(item.id);
          }}
        >
          Remove
	  </Link> */}
        <br />
        {item.doc_fax_id !== 0 && item?.document_sent === '1' && (
          <div className="ref-act-pills">Fax sent</div>
        )}
      </div>

    </>
  );
}

export default ReferralList;
